import React from "react";
import GlobalStyle from "../../styles/GlobalStyle";
import { scaleVertical, FontSizes } from "../../styles/responsive";
import { V2ReportStyle } from "../../styles/V2ReportStyle";
import { DentalIconSvg } from "../../utils/Svgs";

const SectionHeading = ({
  icon = <DentalIconSvg />,
  title = "  Examination of Gingiva",
}: {
  icon: React.ReactNode;
  title: string;
}) => {
  return (
    <div
      style={{
        ...V2ReportStyle.flexRowCenter,
        paddingBottom: scaleVertical(5),
      }}
    >
      {icon}

      <span
        style={{
          ...GlobalStyle.blackBoldText,
          fontSize: "2.2rem",
          marginLeft: "8px", // Added spacing to ensure icon and text are separated
        }}
      >
        {title}
      </span>
    </div>
  );
};

export default SectionHeading;
